import styled from '@emotion/styled';
import { Magnetic as Mi } from '@mitchell/react.component.ux';
export const StyledOverlayDiv = styled('div') `
	background-color: ${Mi.colorBlack};
	z-index: 99999;
	opacity: 0.7;
	position: fixed;
	height: 100%;
	width: ${(props) => (props.shouldAllowMitchellIntelligent ? '100%' : '700px')};
`;
export const StyledSpinnerDiv = styled('div') `
	position: fixed;
	background-color: ${Mi.colorWhite};
	z-index: 99999;
	opacity: 0.7;
	left: calc(50% - 30px);
	height: 70px;
	width: 70px;
	border-radius: 50%;
	top: calc(50% - 30px);
`;
export const StyledDivShellContainer = styled.div `
	display: flex;
	flex-direction: row;
	min-height: 100%;
	max-width: ${(props) => (props.shouldAllowMitchellIntelligent ? 'none' : '700px')};
	margin: 0 auto;
	background-color: ${(props) => props.backgroundColor};
`;
export const StyledDivContent = styled.div `
	display: flex;
	flex-direction: column;
	position: relative;
	width: ${Mi.formControlCoreWidth};
`;
//# sourceMappingURL=GPCLoaderComponent.style.js.map